import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqImportarInput', {
    template: template,
    controller: NominasCargacontpaqImportarInputComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
  });

function NominasCargacontpaqImportarInputComponent() {
  let $ctrl = this;

  $ctrl.aceptar = aceptar;
  $ctrl.borrar = borrar;
  $ctrl.error = null;

  function aceptar() {
    let rows,
      headers;

    if (!$ctrl.data)
      return;

    $ctrl.error = null;

    rows = $ctrl.data.split('\n')
      .map(function (row) {
        return row.split('\t');
      });

    headers = rows.splice(0, 1)[0];

    if (rows.length)
      $ctrl.onChange({$event: {data: {rows: rows, headers: headers}}});
    else
      $ctrl.error = 'No hay suficientes lineas para procesar.';
  }

  function borrar() {
    $ctrl.data = '';
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/importar/input/component.js